import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'image',
  name: '图片',
  icon: '图',
  group: '基础组件',
  description: '展示单张图片并支持跳转',
  defaultProps: {
    imageUrl: '',
    altText: '',
    fitMode: 'COVER',
    linkTarget: ''
  }
}
